/* eslint-disable no-console */
const LOG_PREFIX = 'NUACOM-LOG';
const STORAGE_LOGS_KEY = '@consoleLog';

const colors = {
  riverBed: '#3d505a',
  parsleyGreen: '#155724',
  persianPlumRed: '#721C24',
  muddyBrown: '#856404',
  darkCeruleanBlue: '#004085',
};

const log = {
  isEnabled: (): boolean => localStorage.getItem(STORAGE_LOGS_KEY) === 'true',

  debug: (message: string, ...extraParams: unknown[]): void => {
    if (log.isEnabled()) {
      console.info(
        `%c${LOG_PREFIX}: %c[DEBUG] %c${message}`,
        `color: ${colors.riverBed}`,
        `color: ${colors.darkCeruleanBlue} font-weight: bold;`,
        'color: inherit;',
        ...extraParams
      );
    }
  },

  info: (message: string, ...extraParams: unknown[]): void => {
    if (log.isEnabled()) {
      console.info(
        `%c${LOG_PREFIX}: %c[INFO] %c${message}`,
        `color: ${colors.riverBed}`,
        `color: ${colors.parsleyGreen}; font-weight: bold;`,
        'color: inherit;',
        ...extraParams
      );
    }
  },

  error: (message: string, ...extraParams: unknown[]): void => {
    if (log.isEnabled()) {
      const [firstParams] = extraParams;

      // @ts-ignore cancelled requests
      if (firstParams?.code === 'ERR_CANCELED') {
        console.warn(
          `%c${LOG_PREFIX}: %c[WARN] %c${message}`,
          `color: ${colors.riverBed}`,
          `color: ${colors.muddyBrown}; font-weight: bold;`,
          'color: inherit;',
          ...extraParams
        );
      } else {
        console.error(
          `%c${LOG_PREFIX}: %c[ERROR] %c${message}`,
          `color: ${colors.riverBed}`,
          `color: ${colors.persianPlumRed}; font-weight: bold;`,
          'color: inherit;',
          ...extraParams
        );
      }
    }
  },

  warn: (message: string, ...extraParams: unknown[]): void => {
    if (log.isEnabled()) {
      console.warn(
        `%c${LOG_PREFIX}: %c[WARN] %c${message}`,
        `color: ${colors.riverBed}`,
        `color: ${colors.muddyBrown}; font-weight: bold;`,
        'color: inherit;',
        ...extraParams
      );
    }
  },
};

export default log;
